import React from 'react'
import styled from 'styled-components'
import { Types } from '../../types';
import { MobileMenuContext } from '../../contexts/MobileMenu';
import Toggler from './Toggler'

/**
 * Hamburger component to render a menu opener 
 * @param props IMegaMenuOptions
 * @returns React FC
 */
const Hamburger: React.FC<Types.AppOptions> = (props) => {
  // Expand action handler
  const { toggleBoolState } = React.useContext(MobileMenuContext)
  
  return (
    <StyledHamburger tabIndex={10} onClick={() => toggleBoolState('expanded')} {...props}>
      {/* Toggler */}
      <Toggler {...props} iconId={'hamburger'} type={'outlined'} color={props.theme.mobileMenu.hamburgerColor} />
    </StyledHamburger>
  )
}

const StyledButton = styled.button<any>`
  all: unset;
  transition: all;
  font-size: ${({config}) => config.general.sizingBase}px;
`

// Relatively inlined
const StyledHamburger = styled(StyledButton)`
`

export default Hamburger
